// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstitutionList_institution-list__GY4sS {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}
.InstitutionList_institution-list__GY4sS .InstitutionList_results__0E9JL {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
}
.InstitutionList_institution-list__GY4sS .InstitutionList_results__header__VBwDl {
  display: flex;
  padding: 0px 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
}
.InstitutionList_institution-list__GY4sS .InstitutionList_results__body__KfsBe {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}
.InstitutionList_institution-list__GY4sS .InstitutionList_results--controller__GbOCI {
  align-self: flex-end;
}
.InstitutionList_institution-list__GY4sS .InstitutionList_results--title__FnMyu {
  text-align: center;
  color: var(--accent-color);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.InstitutionList_institution-list__GY4sS .InstitutionList_results--description__iBmT6 {
  color: var(--grey-text);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.InstitutionList_institution-list__GY4sS .InstitutionList_right-section__dUyiq {
  max-width: 300px;
  width: 100%;
}
@media only screen and (max-width: 900px) {
  .InstitutionList_institution-list__GY4sS {
    flex-direction: column;
    gap: 20px;
  }
  .InstitutionList_institution-list__GY4sS .InstitutionList_results__0E9JL {
    width: 100%;
  }
  .InstitutionList_institution-list__GY4sS .InstitutionList_results--title__FnMyu {
    font-size: 20px;
  }
  .InstitutionList_institution-list__GY4sS .InstitutionList_right-section__dUyiq {
    max-width: initial;
  }
}

.InstitutionList_card__sf9VZ {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.InstitutionList_card__sf9VZ:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(30, 58, 95, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionList/InstitutionList.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AACF;AACE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AACJ;AACI;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACN;AAEI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAAN;AAGI;EACE,oBAAA;AADN;AAII;EACE,kBAAA;EACA,0BAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAKI;EACE,uBAAA;EACA,kBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAOE;EACE,gBAAA;EACA,WAAA;AALJ;AAQE;EA9DF;IA+DI,sBAAA;IACA,SAAA;EALF;EAOE;IACE,WAAA;EALJ;EAOI;IACE,eAAA;EALN;EASE;IACE,kBAAA;EAPJ;AACF;;AAWA;EACE,oCAAA;EACA,2BAAA;EACA,mCAAA;EACA,0CAAA;EACA,mBAAA;EACA,iDAAA;AARF;AAUE;EACE,2BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mCAAA;AARJ","sourcesContent":[".institution-list {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  gap: 40px;\n\n  .results {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 40px;\n    align-self: stretch;\n\n    &__header {\n      display: flex;\n      padding: 0px 40px;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 12px;\n      align-self: stretch;\n    }\n\n    &__body {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 16px;\n      align-self: stretch;\n    }\n\n    &--controller {\n      align-self: flex-end;\n    }\n\n    &--title {\n      text-align: center;\n      color: var(--accent-color);\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 24px;\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    &--description {\n      color: var(--grey-text);\n      text-align: center;\n      font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n\n  .right-section {\n    max-width: 300px;\n    width: 100%;\n  }\n\n  @media only screen and (max-width: 900px) {\n    flex-direction: column;\n    gap: 20px;\n\n    .results {\n      width: 100%;\n\n      &--title {\n        font-size: 20px;\n      }\n    }\n\n    .right-section {\n      max-width: initial;\n    }\n  }\n}\n\n.card {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 16px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n    background: rgba(255, 255, 255, 0.9);\n    border-color: rgba(30, 58, 95, 0.1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"institution-list": `InstitutionList_institution-list__GY4sS`,
	"results": `InstitutionList_results__0E9JL`,
	"results__header": `InstitutionList_results__header__VBwDl`,
	"results__body": `InstitutionList_results__body__KfsBe`,
	"results--controller": `InstitutionList_results--controller__GbOCI`,
	"results--title": `InstitutionList_results--title__FnMyu`,
	"results--description": `InstitutionList_results--description__iBmT6`,
	"right-section": `InstitutionList_right-section__dUyiq`,
	"card": `InstitutionList_card__sf9VZ`
};
export default ___CSS_LOADER_EXPORT___;
